import React, { PureComponent } from 'react'
import { withTheme } from 'styled-components'

import lo from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import { Label } from 'atoms/Texts'
import IconPng from 'atoms/IconPng'
import Icon from 'atoms/Icon'
import { CardContainer, BorderContainer } from './styles'
import ic_doc from 'App/assets/images/ic-file-doc.png'
import ic_sheet from 'App/assets/images/ic-file-sheet.png'
import ic_pdf from 'App/assets/images/ic-file-pdf.png'
import ic_upload_file from 'App/assets/images/ic_upload_file.png'
import { SERVER_URL } from 'fixtures/api'

const FILE_TYPES = {
  'doc': ic_doc,
  'docx': ic_doc,
  'xls': ic_sheet,
  'xlsx': ic_sheet,
  'pdf': ic_pdf,
}

export class Attachments extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      attachments: []
    }
  }

  onChangeVal(value, id) {
    const { blastingReportData, fnChange } = this.props
    for (var i = 0; i < value.length; i++) {
      const file = value[i]
      let reader = new FileReader()
      reader.addEventListener("load", (event) => {
        const reportData = lo.cloneDeep(blastingReportData)
        const details = reportData.details
        const newFile = {
          id: uuidv4(),
          filename: file.name,
          mimeType: file.type,
          media: { type: 'DOCUMENT'},
          others: null,
          file: event.target.result.split(',')[1]
        }
        const pitIndex = details.detailPit.findIndex((pit => pit.id === id));
        details.detailPit[pitIndex]['attachments'].push(newFile)
        fnChange(details, 'details')
      })
      reader.readAsDataURL(file)
    }
  }

  fnRemoveAttachment(pitId, fileId) {
    const { blastingReportData, fnChange } = this.props
    const reportData = lo.cloneDeep(blastingReportData)
    const details = reportData.details
    const pitIndex = details.detailPit.findIndex((pit => pit.id === pitId));
    details.detailPit[pitIndex]['attachments'] = details.detailPit[pitIndex]['attachments'].filter(pit => pit.id !== fileId)
    fnChange(details, 'details')
  }

  getExtension(filename) {
    let arr = filename.split('.');
    let extension = arr.pop();
    return extension
  }

  downloadAttachment(e, blastingReportData) {
    if (blastingReportData.hasOwnProperty('attachments')) {
      const attachmentData = blastingReportData.attachments.find(attachment => attachment.id === e.id)
      if (attachmentData && attachmentData.media.contentUrl) {
        fetch(`${SERVER_URL}${attachmentData.media.contentUrl}`)
          .then(response => response.blob())
          .then(blob => {
            const newBlob = new Blob([blob], { type: attachmentData.mimeType })
            const newUrl = URL.createObjectURL(newBlob)
            const downloadLink = document.createElement('a')
            downloadLink.href = newUrl
            downloadLink.download = attachmentData.filename
            downloadLink.click()
            URL.revokeObjectURL(newUrl)
          })
      }
    }
  }

  render() {
    const { theme, pit, isDisabled, blastingReportData } = this.props

    return (
      <div className={'row col-12 mx-0 px-0'}>
        <CardContainer mb={'16px'}>
          <div className={'row col-12 mx-0 px-0'}>
            <Label lineheight={'21px'} size={'14px'} mb={'0px'} color={'#473A94'}>
              Attachments
            </Label>
          </div>
          <div className={'row col-12 mx-0 px-0 my-2'}>
            <BorderContainer 
              borderColor={theme.mocaPurple} 
              width={'60px'}
              height={'60px'}
              mr={'8px'}
              showPointer 
              onClick={() => {
                // limit only 5 attachments per pit
                if (!isDisabled && pit.attachments.length < 5) {
                  document.getElementById(`attachments-${pit.id}`).click()
                }
              }}
            >
              <IconPng srcIcon={ic_upload_file} mx={"8px"} size={"auto"} h={"24"} showPointer />
            </BorderContainer>
            <input
              id={`attachments-${pit.id}`}
              type="file"
              accept={Object.keys(FILE_TYPES).map(extension => `.${extension}`).join(',')}
              onChange={e => this.onChangeVal(e.target.files, pit.id)}
              multiple
              hidden
            />
            { pit.attachments.length > 0 &&
              pit.attachments.map((e, i) => (
                <BorderContainer key={i} width={'60px'} height={'60px'} mr={'8px'} padding={'2px 5px'} justify={'space-between'}>
                  <Icon
                    ml="auto"
                    name="times-circle"
                    color={theme.mocaRed}
                    onClick={() => !isDisabled ? this.fnRemoveAttachment(pit.id, e.id) : {}}
                    size="xs"
                    height={'10px'}
                    mt={'-5px'}
                    showPointer
                  />
                  <IconPng
                    srcIcon={FILE_TYPES[this.getExtension(e.filename)]}
                    mx={"8px"}
                    size={"auto"}
                    h={"24"}
                    onClick={() => this.downloadAttachment(e, blastingReportData)}
                    {...(blastingReportData.hasOwnProperty("attachments") &&
                      blastingReportData.attachments.find(
                        (attachment) =>
                          attachment.id === e.id &&
                          attachment.media &&
                          attachment.media.contentUrl
                      ) && { showPointer: true })}
                  />
                  <Label weight={'normal'} lineheight={'12px'} size={'10px'} color={theme.mocaGrey} mb={'4px'} textOverflow width={'45px'}>
                    {e.filename}
                  </Label>
                </BorderContainer>
              ))
            }
          </div>
        </CardContainer>
      </div>
    )
  }
}

export default withTheme(Attachments)
